// extracted by mini-css-extract-plugin
export default {"overlay":"Sx-z","bodyOpen":"Tx-z","content":"Ux-z","header":"Vx-z","close":"Wx-z","closeNoHeading":"Xx-z"};